import { lazyWithRetry } from 'components/lazyUtil.js'

const PartnerProfile = lazyWithRetry(() => import('../../partners/partnerProfile/partnerProfile.js'))

// IMPORTANT //
// In Future: whenever new route path is added ensure to update "validPaths" in /server/validRoutes.js
const routes = [
  {
    path: '/partners/:userID',
    component: PartnerProfile,
    private: false,
  },
]

export default routes
